// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8SSjm","type":"styles_type__2OMLw","choices":"styles_choices__Vhdic"};